<template>
  <VModal ref="modal" @modal:hidden="$emit('hide')" disable-backdrop-click>
    <div class="w-full max-w-lg mx-auto">
      <BaseCard @click.stop>
        <BaseCardBody>
          <NexmoSmsForm
            v-if="isNexmoSms"
            :default-data="thirdPartyService"
            :action="updateThirdPartyService"
            @cancel="$refs.modal.close()"
          />
          <MailSmtpForm
            v-else-if="isCustomEmail"
            :default-data="thirdPartyService"
            :action="updateThirdPartyService"
            @cancel="$refs.modal.close()"
          />
          <div v-else>Cannot handle {{ this.service }}/{{ this.channel }}</div>
        </BaseCardBody>
      </BaseCard>
    </div>
  </VModal>
</template>

<script>
import BaseCard from 'Components/BaseCard.vue';
import NexmoSmsForm from './NexmoSmsForm.vue';
import MailSmtpForm from './MailSmtpForm.vue';

export default {
  components: {
    NexmoSmsForm,
    MailSmtpForm,
    BaseCard,
  },
  props: {
    thirdPartyService: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isNexmoSms() {
      return (
        this.thirdPartyService.service === 'vonage' && this.thirdPartyService.channel === 'sms'
      );
    },
    isCustomEmail() {
      return (
        this.thirdPartyService.service === 'custom email' &&
        this.thirdPartyService.channel === 'mail'
      );
    },
  },
  methods: {
    async updateThirdPartyService(formData) {
      try {
        await this.$store.dispatch('ui/thirdPartyServices/update', {
          id: this.thirdPartyService.id,
          formData,
        });

        this.$refs.modal.close();

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
